/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './payment';
import './emv';
import './network_token';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "tender": {
            "nested": {
              "VerificationData": {
                "fields": {
                  "securityCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationYymm": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "authenticationResult": {
                    "type": ".squareup.common.tender.AuthenticationResult",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardholderName": {
                    "type": ".squareup.common.tender.CardHolderName",
                    "id": 8,
                    "rule": "optional"
                  },
                  "ebtVoucherNumber": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "pinData": {
                    "type": ".squareup.common.tender.SquareReaderPinData",
                    "id": 3
                  },
                  "hieroglyphPinData": {
                    "type": ".squareup.common.tender.HieroglyphEncryptedPinData",
                    "id": 6
                  },
                  "applePinData": {
                    "type": ".squareup.common.tender.AppleEncryptedPinData",
                    "id": 7
                  }
                },
                "nested": {
                  "PinRelatedData": {
                    "oneof": ["pinData", "hieroglyphPinData", "applePinData"]
                  }
                }
              },
              "AuthenticationResult": {
                "fields": {
                  "mandate": {
                    "type": ".squareup.common.tender.AuthenticationResult.Mandate",
                    "id": 13,
                    "rule": "optional"
                  },
                  "riskRecommendation": {
                    "type": ".squareup.common.tender.AuthenticationResult.RiskRecommendation",
                    "id": 14,
                    "rule": "optional"
                  },
                  "riskChargebackLiabilityRecommendation": {
                    "type": ".squareup.common.tender.AuthenticationResult.ChargebackLiability",
                    "id": 23,
                    "rule": "optional"
                  },
                  "scaExemption": {
                    "type": ".squareup.common.tender.AuthenticationResult.ScaExemption",
                    "id": 24,
                    "rule": "optional"
                  },
                  "chargebackLiableParty": {
                    "type": ".squareup.common.tender.AuthenticationResult.ChargebackLiability",
                    "id": 26,
                    "rule": "optional"
                  },
                  "chargebackLiabilityReason": {
                    "type": ".squareup.common.tender.AuthenticationResult.ChargebackLiabilityReason",
                    "id": 27,
                    "rule": "optional"
                  },
                  "scope": {
                    "type": ".squareup.common.tender.AuthenticationResult.Scope",
                    "id": 15,
                    "rule": "optional"
                  },
                  "scopeReason": {
                    "type": ".squareup.common.tender.AuthenticationResult.ScopeReason",
                    "id": 28,
                    "rule": "optional"
                  },
                  "isSuccess": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.common.tender.ThreeDSFailureReason",
                    "id": 11,
                    "rule": "optional"
                  },
                  "threeDsError": {
                    "type": ".squareup.common.tender.ThreeDSError",
                    "id": 12,
                    "rule": "optional"
                  },
                  "authenticationValue": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "eciValue": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "transactionStatus": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "transactionStatusReason": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "authnResponseTransactionStatus": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "resultsRequestTransactionStatus": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "protocolVerison": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "directoryServerId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "wasChallenged": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "threeDsServerTxnId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "threedsToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "challengeCancel": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "authorizationRecommendation": {
                    "type": ".squareup.common.tender.AuthenticationResult.AuthorizationRecommendation",
                    "id": 16,
                    "rule": "optional"
                  },
                  "customScore": {
                    "type": "int32",
                    "id": 18,
                    "rule": "optional"
                  },
                  "squareProduct": {
                    "type": ".squareup.common.payment.SquareProduct",
                    "id": 19,
                    "rule": "optional"
                  },
                  "authenticationProvider": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "directoryServerIdentifier": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "verificationToken": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "authnRequestorUnitToken": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "authnRequestorMerchantToken": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Mandate": {
                    "values": {
                      "UNKNOWN_MANDATE": 0,
                      "MANDATED": 1,
                      "NOT_MANDATED": 2
                    }
                  },
                  "RiskRecommendation": {
                    "values": {
                      "UNKNOWN_RISK_RECOMMENDATION": 0,
                      "RECOMMEND_IN_SCOPE": 1,
                      "RECOMMEND_IN_SCOPE_FRICTIONLESS": 2,
                      "RECOMMEND_OUT_OF_SCOPE": 3,
                      "RECOMMEND_DECLINED_AUTHORIZATION": 4,
                      "RECOMMENDATION_TIMED_OUT": 5,
                      "RECOMMENDATION_FAILED": 6,
                      "RECOMMENDATION_NOT_REQUESTED": 7
                    }
                  },
                  "ChargebackLiability": {
                    "values": {
                      "UNKNOWN_LIABILITY": 0,
                      "ISSUER_LIABILITY": 1,
                      "SQUARE_LIABILITY": 2,
                      "SELLER_LIABILITY": 3
                    }
                  },
                  "ChargebackLiabilityReason": {
                    "values": {
                      "UNKNOWN_LIABILITY_REASON": 0,
                      "THREE_DS_AUTHENTICATED": 1,
                      "OPTIMISTIC_AUTHORIZATION": 2,
                      "DATA_ONLY_DEFAULT_SELLER": 3,
                      "TRA_EXEMPTION_SUCCESSFUL": 4,
                      "DIGITAL_WALLET_AUTHENTICATED": 5,
                      "SELLER_DEFAULT": 6
                    }
                  },
                  "ScaExemption": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "TRA_EXEMPTION": 1
                    }
                  },
                  "Scope": {
                    "values": {
                      "UNKNOWN_SCOPE": 0,
                      "IN_SCOPE": 1,
                      "OUT_OF_SCOPE": 2,
                      "DATA_ONLY": 3
                    }
                  },
                  "ScopeReason": {
                    "values": {
                      "UNKNOWN_SCOPE_REASON": 0,
                      "ANONYMOUS_PREPAID_CARD": 1,
                      "BY_FEATURE_FLAG": 2,
                      "FORCED_TEST_PAN": 3,
                      "INTERNAL_ERROR": 4,
                      "UNSUPPORTED_BIN": 5,
                      "NO_CARD_BRAND": 6,
                      "UNSUPPORTED_CARD_BRAND": 7,
                      "RISK_RECOMMEND": 8,
                      "RISK_RECOMMEND_DECLINED_AUTHORIZATION": 9,
                      "RISK_RECOMMEND_TIMED_OUT": 10,
                      "RISK_RECOMMENDED_UNKNOWN": 11,
                      "SANDBOX": 12,
                      "UNSUPPORTED_TEST_MERCHANT": 13,
                      "DEFAULT_SCOPE": 14
                    }
                  },
                  "AuthorizationRecommendation": {
                    "values": {
                      "UNKNOWN": 0,
                      "AUTHORIZE": 1,
                      "NO_RECOMMENDATION": 5,
                      "DO_NOT_AUTHORIZE": 2,
                      "DO_NOT_AUTHORIZE_REJECTED_AUTHENTICATION": 3,
                      "DO_NOT_AUTHORIZE_BLOCKED_BY_RISK": 4
                    }
                  }
                }
              },
              "SquareReaderPinData": {
                "fields": {
                  "encryptedPinBlock": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ksn": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pinBlockMac": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "pseudoPan": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "HieroglyphEncryptedPinData": {
                "fields": {
                  "pseudoPan": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedPinKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "encryptedPinHmacKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "encryptedPinBlock": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "encryptedPinHmac": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "AppleEncryptedPinData": {
                "fields": {
                  "encryptedPinKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedPinBlock": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ChipCard": {
                "fields": {
                  "emvTags": {
                    "type": ".squareup.common.EmvTags",
                    "id": 1,
                    "rule": "optional"
                  },
                  "emvInputType": {
                    "type": ".squareup.common.tender.ChipCard.EmvInputType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ecrPinData": {
                    "type": ".squareup.common.tender.HieroglyphEncryptedPinData",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "EmvInputType": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "CONTACT": 1,
                      "CONTACTLESS": 2
                    }
                  }
                }
              },
              "KeyedCard": {
                "fields": {
                  "unencryptedPan": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expiration": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "securityCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tokenData": {
                    "type": ".squareup.common.tender.TokenData",
                    "id": 5,
                    "rule": "optional"
                  },
                  "digitalWalletType": {
                    "type": ".squareup.common.tender.DigitalWalletType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": ".squareup.common.tender.AccountType",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "DigitalWalletType": {
                "values": {
                  "UNKNOWN_DIGITAL_WALLET_TYPE": 0,
                  "APPLE_PAY_WEB": 1,
                  "APPLE_PAY_INAPP": 2,
                  "MASTERPASS": 5,
                  "GOOGLE_PAY_WEB": 6,
                  "GOOGLE_PAY_INAPP": 7,
                  "CLICK_TO_PAY_WEB": 8,
                  "CLICK_TO_PAY_INAPP": 9
                }
              },
              "TokenData": {
                "fields": {
                  "variant": {
                    "type": ".squareup.common.tender.TokenData.TokenVariant",
                    "id": 1,
                    "rule": "optional"
                  },
                  "method": {
                    "type": ".squareup.common.tender.TokenData.TokenMethod",
                    "id": 2,
                    "rule": "optional"
                  },
                  "electronicCommerceIndicator": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cryptogram": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tokenRequestorId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "masterpassWalletId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "displayPanSuffix": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "expirationYymm": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TokenVariant": {
                    "values": {
                      "UNKNOWN_TOKEN_VARIANT": 0,
                      "APPLE_PAY_WEB": 1,
                      "APPLE_PAY_INAPP": 2,
                      "ANDROID_PAY_WEB": 3,
                      "ANDROID_PAY_INAPP": 4,
                      "MASTERPASS": 5,
                      "GOOGLE_PAY_WEB": 6,
                      "GOOGLE_PAY_INAPP": 7,
                      "CLICK_TO_PAY_WEB": 8,
                      "CLICK_TO_PAY_INAPP": 9
                    }
                  },
                  "TokenMethod": {
                    "values": {
                      "UNKNOWN": 0,
                      "THREE_D_SECURE": 1
                    }
                  }
                }
              },
              "SwipedCard": {
                "fields": {
                  "encryptedTrack2": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unencryptedTrack2": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "encryptedCardData": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "unencryptedTrack1": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": ".squareup.common.tender.AccountType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "ebtPinData": {
                    "type": ".squareup.common.tender.HieroglyphEncryptedPinData",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "FideliusToken": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expiration": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "customerToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FelicaCard": {
                "fields": {
                  "customerIdentifier": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "brandId": {
                    "type": ".squareup.common.tender.FelicaCard.FelicaBrand",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transactionId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FelicaBrand": {
                    "values": {
                      "UNKNOWN": 0,
                      "FELICA_ID": 1,
                      "FELICA_TRANSPORTATION": 2,
                      "FELICA_QP": 3
                    }
                  }
                }
              },
              "ServerCompleted": {
                "fields": {
                  "preauthIdempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "brand": {
                    "type": ".squareup.common.tender.ServerCompleted.ServerCompletedBrand",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transactionId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "serverCompletedVersion": {
                    "type": ".squareup.common.tender.ServerCompleted.ServerCompletedVersion",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ServerCompletedBrand": {
                    "values": {
                      "UNKNOWN": 0,
                      "ALIPAY": 1,
                      "CASH_APP": 2,
                      "PAYPAY": 3,
                      "AFTERPAY": 4,
                      "AU_PAY": 5,
                      "WECHAT_PAY": 6,
                      "D_BARAI": 7,
                      "RAKUTEN_PAY": 8,
                      "MERPAY": 9,
                      "ALIPAY_PLUS": 10,
                      "MER_PAY": 11,
                      "STORED_VALUE": 12,
                      "CASH_LOCAL": 13,
                      "LOCAL_CASH": 14
                    }
                  },
                  "ServerCompletedVersion": {
                    "values": {
                      "UNKNOWN_VERSION": 0,
                      "CASH_APP_V0": 1,
                      "CASH_APP_V1": 2
                    }
                  }
                }
              },
              "HouseAccountTender": {
                "fields": {
                  "fideliusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "houseAccountToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CardOnFileTender": {
                "fields": {
                  "cardId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fideliusToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verificationPaymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "unencryptedPan": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "storedCardPaymentData": {
                    "type": "bytes",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CardOnFile": {
                "fields": {
                  "cardId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "verificationPaymentId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "storedCardPaymentData": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "TokenizedCard": {
                "fields": {
                  "fideliusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unencryptedPan": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationYymm": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cryptogram": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  },
                  "securityCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "electronicCommerceIndicator": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "masterpassWalletId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "networkTokenData": {
                    "type": ".squareup.common.NetworkTokenData",
                    "id": 9,
                    "rule": "optional"
                  },
                  "displayPanSuffix": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "cardholderName": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "digitalWalletType": {
                    "type": ".squareup.common.tender.DigitalWalletType",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "InvalidEncryptedTender": {
                "fields": {
                  "tenderInputType": {
                    "type": ".squareup.common.tender.TenderInputType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": ".squareup.common.tender.InvalidEncryptedTender.Reason",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Reason": {
                    "values": {
                      "UNKNOWN": 0,
                      "UNDECRYPTABLE_OFFLINE_PAYLOAD": 1,
                      "UNDECRYPTABLE_TENDER_PAYLOAD": 2
                    }
                  }
                }
              },
              "CardTender": {
                "fields": {
                  "keyedCard": {
                    "type": ".squareup.common.tender.KeyedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "swipedCard": {
                    "type": ".squareup.common.tender.SwipedCard",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fideliusToken": {
                    "type": ".squareup.common.tender.FideliusToken",
                    "id": 3,
                    "rule": "optional"
                  },
                  "verificationData": {
                    "type": ".squareup.common.tender.VerificationData",
                    "id": 4,
                    "rule": "optional"
                  },
                  "chipCard": {
                    "type": ".squareup.common.tender.ChipCard",
                    "id": 5,
                    "rule": "optional"
                  },
                  "felicaCard": {
                    "type": ".squareup.common.tender.FelicaCard",
                    "id": 6,
                    "rule": "optional"
                  },
                  "serverCompleted": {
                    "type": ".squareup.common.tender.ServerCompleted",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardOnFile": {
                    "type": ".squareup.common.tender.CardOnFileTender",
                    "id": 8,
                    "rule": "optional"
                  },
                  "tokenizedCard": {
                    "type": ".squareup.common.tender.TokenizedCard",
                    "id": 9,
                    "rule": "optional"
                  },
                  "houseAccount": {
                    "type": ".squareup.common.tender.HouseAccountTender",
                    "id": 10,
                    "rule": "optional"
                  },
                  "invalidEncryptedTender": {
                    "type": ".squareup.common.tender.InvalidEncryptedTender",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "CardTenderType": {
                "values": {
                  "UNKNOWN": 1,
                  "VISA": 2,
                  "MASTER_CARD": 3,
                  "AMERICAN_EXPRESS": 4,
                  "DISCOVER": 5,
                  "DISCOVER_DINERS": 6,
                  "JCB": 7,
                  "UNION_PAY": 8,
                  "SQUARE_GIFT_CARD_V2": 9,
                  "INTERAC": 10,
                  "SQUARE_CAPITAL_CARD": 11,
                  "EFTPOS": 12,
                  "FELICA": 13,
                  "ALIPAY": 14,
                  "CASH_APP": 15,
                  "EBT": 16,
                  "PAYPAY": 17,
                  "AFTERPAY": 18,
                  "SQUARE_ACCOUNT_BALANCE": 19,
                  "AU_PAY": 20,
                  "WECHAT_PAY": 21,
                  "D_BARAI": 22,
                  "MERPAY": 23,
                  "RAKUTEN_PAY": 24,
                  "STORED_VALUE": 25,
                  "QUICPAY": 26,
                  "ID": 27,
                  "TRANSPORTATION_IC": 28,
                  "CASH_LOCAL": 29,
                  "LOCAL_CASH": 30
                }
              },
              "TenderInputType": {
                "values": {
                  "DEFAULT_TENDER_INPUT_TYPE": 0,
                  "MANUAL": 1,
                  "TRACK1": 2,
                  "TRACK2": 3,
                  "ENCRYPTED_TRACK": 4,
                  "TOKEN": 5,
                  "EMV_READER": 6,
                  "CONTACTLESS": 7,
                  "FELICA_CONTACTLESS": 8,
                  "SERVER_COMPLETED": 9,
                  "TRACK1_2": 10,
                  "CARD_ON_FILE": 14,
                  "TOKENIZED_CARD": 15,
                  "TOKENIZED_CARD_ON_FILE": 16
                }
              },
              "AccountType": {
                "values": {
                  "UNKNOWN_ACCOUNT_TYPE": 0,
                  "SAVINGS": 1,
                  "CHECKING": 2,
                  "CREDIT": 3,
                  "EBT_CASH": 4,
                  "EBT_FOOD": 5
                }
              },
              "ThreeDSFailureReason": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 1,
                  "COULD_NOT_AUTHENTICATE_CARD_NOT_SUPPORTED": 2,
                  "COULD_NOT_AUTHENTICATE_3DS_SERVER_FAILURE": 4,
                  "DECLINED": 3
                }
              },
              "ThreeDSError": {
                "fields": {
                  "errorCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorComponent": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errorDescription": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errorDetail": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CardHolderName": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "middleName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.VerificationData && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.Mandate && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.RiskRecommendation && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.ChargebackLiability && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.ChargebackLiabilityReason && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.ScaExemption && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.Scope && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.ScopeReason && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AuthenticationResult?.nested?.AuthorizationRecommendation && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.SquareReaderPinData && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.HieroglyphEncryptedPinData && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AppleEncryptedPinData && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ChipCard && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ChipCard?.nested?.EmvInputType && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.KeyedCard && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.DigitalWalletType && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.TokenData && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.TokenData?.nested?.TokenVariant && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.TokenData?.nested?.TokenMethod && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.SwipedCard && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.FideliusToken && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.FelicaCard && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.FelicaCard?.nested?.FelicaBrand && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ServerCompleted && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ServerCompleted?.nested?.ServerCompletedBrand && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ServerCompleted?.nested?.ServerCompletedVersion && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.HouseAccountTender && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.CardOnFileTender && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.CardOnFile && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.TokenizedCard && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.InvalidEncryptedTender && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.InvalidEncryptedTender?.nested?.Reason && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.CardTender && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.CardTenderType && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.TenderInputType && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.AccountType && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ThreeDSFailureReason && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.ThreeDSError && !$root.nested?.squareup?.nested?.common?.nested?.tender?.nested?.CardHolderName) {
  $root.addJSON(jsonData);
}

/**
 * Container field for verification-related info for card processing.
 * If necessary, this field will be utilized at application level, but
 * disregarded if not needed. Present outside *Card messages in order
 * to support future forms of tender.
 *
 * SOURCE VerificationData @ squareup/common/tender.proto at 21:1
 */
export const VerificationData = $root.lookupType('squareup.common.tender.VerificationData');
fixType(VerificationData);
Builder.createAndAttachToType(VerificationData);
/**
 * Verification data representing the result of an attempted cardholder
 * authentication. Authentication is currently performed for eCommerce
 * transactions in UK/AU via the 3DS 2.0 protocol, but this proto is intended
 * to generically contain data for any cardholder authentication performed
 * by Square prior to Authorization.  In the generic case, the populated fields
 * may be dependent on the protocol used.
 *
 * SOURCE AuthenticationResult @ squareup/common/tender.proto at 49:1
 */
export const AuthenticationResult = $root.lookupType('squareup.common.tender.AuthenticationResult');
fixType(AuthenticationResult);
Builder.createAndAttachToType(AuthenticationResult);
/**
 * NEXT ID 32;
 * Indicates whether 3DS is mandated based on the current transaction's information
 *
 * SOURCE Mandate @ squareup/common/tender.proto at 177:3
 */
AuthenticationResult.Mandate = $root.lookupEnum('squareup.common.tender.AuthenticationResult.Mandate').values;
/**
 * Indicates what was the recommendation provided by Square's Risk Infrastructure
 *
 * SOURCE RiskRecommendation @ squareup/common/tender.proto at 188:3
 */
AuthenticationResult.RiskRecommendation = $root.lookupEnum('squareup.common.tender.AuthenticationResult.RiskRecommendation').values;
/**
 * Indicates what liability shift Risk recommends
 *
 * SOURCE ChargebackLiability @ squareup/common/tender.proto at 217:4
 */
AuthenticationResult.ChargebackLiability = $root.lookupEnum('squareup.common.tender.AuthenticationResult.ChargebackLiability').values;
/**
 * Reason that determines LiableParty field on AuthenticationResult
 *
 * SOURCE ChargebackLiabilityReason @ squareup/common/tender.proto at 229:4
 */
AuthenticationResult.ChargebackLiabilityReason = $root.lookupEnum('squareup.common.tender.AuthenticationResult.ChargebackLiabilityReason').values;
/**
 * Indicates what SCA Exemption was applied during authentication. Only applicable for mandated markets
 *
 * SOURCE ScaExemption @ squareup/common/tender.proto at 262:3
 */
AuthenticationResult.ScaExemption = $root.lookupEnum('squareup.common.tender.AuthenticationResult.ScaExemption').values;
/**
 * Indicates whether the transaction is considered in scope for 3DS
 *
 * SOURCE Scope @ squareup/common/tender.proto at 272:3
 */
AuthenticationResult.Scope = $root.lookupEnum('squareup.common.tender.AuthenticationResult.Scope').values;
/**
 * Reason for Scope
 *
 * SOURCE ScopeReason @ squareup/common/tender.proto at 285:3
 */
AuthenticationResult.ScopeReason = $root.lookupEnum('squareup.common.tender.AuthenticationResult.ScopeReason').values;
/**
 * Indicates what the authorization recommendation is. If authorization is not recommended the
 *  reason is encoded in the enum value.
 *
 * SOURCE AuthorizationRecommendation @ squareup/common/tender.proto at 307:3
 */
AuthenticationResult.AuthorizationRecommendation = $root.lookupEnum('squareup.common.tender.AuthenticationResult.AuthorizationRecommendation').values;
/**
 * Wrapper for PIN-related data.
 *
 * SOURCE SquareReaderPinData @ squareup/common/tender.proto at 323:1
 */
export const SquareReaderPinData = $root.lookupType('squareup.common.tender.SquareReaderPinData');
fixType(SquareReaderPinData, {
  encryptedPinBlock: {
    required: true
  },
  ksn: {
    required: true
  },
  pinBlockMac: {
    required: true
  }
});
Builder.createAndAttachToType(SquareReaderPinData);
/**
 * Data that is needed in order to translate online PIN blocks for payments like ECR and EBT
 *
 * SOURCE HieroglyphEncryptedPinData @ squareup/common/tender.proto at 348:1
 */
export const HieroglyphEncryptedPinData = $root.lookupType('squareup.common.tender.HieroglyphEncryptedPinData');
fixType(HieroglyphEncryptedPinData);
Builder.createAndAttachToType(HieroglyphEncryptedPinData);
/**
 * Data that is needed in order to translate online PIN blocks for Apple Tap to Pay transactions
 *
 * SOURCE AppleEncryptedPinData @ squareup/common/tender.proto at 359:1
 */
export const AppleEncryptedPinData = $root.lookupType('squareup.common.tender.AppleEncryptedPinData');
fixType(AppleEncryptedPinData);
Builder.createAndAttachToType(AppleEncryptedPinData);
/**
 * Represents a chip credit card that was either dipped or tapped through the reader.
 *
 * SOURCE ChipCard @ squareup/common/tender.proto at 386:1
 */
export const ChipCard = $root.lookupType('squareup.common.tender.ChipCard');
fixType(ChipCard);
Builder.createAndAttachToType(ChipCard);
/**
 * Whether this chip card was contact EMV or contactless (EMV or MSD).
 *
 * SOURCE EmvInputType @ squareup/common/tender.proto at 390:3
 */
ChipCard.EmvInputType = $root.lookupEnum('squareup.common.tender.ChipCard.EmvInputType').values;
/**
 * Represents a credit card whose information was manually entered.
 * All fields must be populated.
 *
 * SOURCE KeyedCard @ squareup/common/tender.proto at 409:1
 */
export const KeyedCard = $root.lookupType('squareup.common.tender.KeyedCard');
fixType(KeyedCard);
Builder.createAndAttachToType(KeyedCard);
/**
 * For Digital Wallet Payments, the type we're using.
 *  This enum mirrors the TokenVariant enum
 *
 *  Positions 3 and 4 are left empty to reflect the
 *  Deprecation of the ANDROID_PAY_WEB and ANDROID_PAY_INAPP fields respectively
 *
 * SOURCE DigitalWalletType @ squareup/common/tender.proto at 458:1
 */
export const DigitalWalletType = $root.lookupEnum('squareup.common.tender.DigitalWalletType').values;
/**
 * Represents Token Payment data within a KeyedCard tender.
 *
 * SOURCE TokenData @ squareup/common/tender.proto at 472:1
 */
export const TokenData = $root.lookupType('squareup.common.tender.TokenData');
fixType(TokenData);
Builder.createAndAttachToType(TokenData);
/**
 * For Token Payments, the variant we're using.
 *  This enum mirrors the DigitalWalletType enum
 *
 *  This enum is slated for Deprecation, for all new fields
 *  use DigitalWalletType
 *
 * SOURCE TokenVariant @ squareup/common/tender.proto at 480:3
 */
TokenData.TokenVariant = $root.lookupEnum('squareup.common.tender.TokenData.TokenVariant').values;
/**
 * Both Apple Pay and Android Pay have "methods". Both only use 3DS now for the things we
 * want. (Apple Pay uses the EMV method only in China.)
 *
 * SOURCE TokenMethod @ squareup/common/tender.proto at 498:3
 */
TokenData.TokenMethod = $root.lookupEnum('squareup.common.tender.TokenData.TokenMethod').values;
/**
 * Represents a credit card that was swiped through card.  Can be
 * either encrypted or unencrypted.
 *
 * SOURCE SwipedCard @ squareup/common/tender.proto at 539:1
 */
export const SwipedCard = $root.lookupType('squareup.common.tender.SwipedCard');
fixType(SwipedCard);
Builder.createAndAttachToType(SwipedCard);
/**
 * SOURCE FideliusToken @ squareup/common/tender.proto at 586:1
 */
export const FideliusToken = $root.lookupType('squareup.common.tender.FideliusToken');
fixType(FideliusToken);
Builder.createAndAttachToType(FideliusToken);
/**
 * SOURCE FelicaCard @ squareup/common/tender.proto at 600:1
 */
export const FelicaCard = $root.lookupType('squareup.common.tender.FelicaCard');
fixType(FelicaCard);
Builder.createAndAttachToType(FelicaCard);
/**
 * SOURCE FelicaBrand @ squareup/common/tender.proto at 601:3
 */
FelicaCard.FelicaBrand = $root.lookupEnum('squareup.common.tender.FelicaCard.FelicaBrand').values;
/**
 * SOURCE ServerCompleted @ squareup/common/tender.proto at 625:1
 */
export const ServerCompleted = $root.lookupType('squareup.common.tender.ServerCompleted');
fixType(ServerCompleted);
Builder.createAndAttachToType(ServerCompleted);
/**
 * SOURCE ServerCompletedBrand @ squareup/common/tender.proto at 626:3
 */
ServerCompleted.ServerCompletedBrand = $root.lookupEnum('squareup.common.tender.ServerCompleted.ServerCompletedBrand').values;
/**
 * SOURCE ServerCompletedVersion @ squareup/common/tender.proto at 657:3
 */
ServerCompleted.ServerCompletedVersion = $root.lookupEnum('squareup.common.tender.ServerCompleted.ServerCompletedVersion').values;
/**
 * SOURCE HouseAccountTender @ squareup/common/tender.proto at 687:1
 */
export const HouseAccountTender = $root.lookupType('squareup.common.tender.HouseAccountTender');
fixType(HouseAccountTender);
Builder.createAndAttachToType(HouseAccountTender);
/**
 * SOURCE CardOnFileTender @ squareup/common/tender.proto at 700:1
 */
export const CardOnFileTender = $root.lookupType('squareup.common.tender.CardOnFileTender');
fixType(CardOnFileTender);
Builder.createAndAttachToType(CardOnFileTender);
/**
 * SOURCE CardOnFile @ squareup/common/tender.proto at 731:1
 */
export const CardOnFile = $root.lookupType('squareup.common.tender.CardOnFile');
fixType(CardOnFile);
Builder.createAndAttachToType(CardOnFile);
/**
 * Represents network token payment data
 *
 * SOURCE TokenizedCard @ squareup/common/tender.proto at 752:1
 */
export const TokenizedCard = $root.lookupType('squareup.common.tender.TokenizedCard');
fixType(TokenizedCard);
Builder.createAndAttachToType(TokenizedCard);
/**
 * SOURCE InvalidEncryptedTender @ squareup/common/tender.proto at 809:1
 */
export const InvalidEncryptedTender = $root.lookupType('squareup.common.tender.InvalidEncryptedTender');
fixType(InvalidEncryptedTender);
Builder.createAndAttachToType(InvalidEncryptedTender);
/**
 * SOURCE Reason @ squareup/common/tender.proto at 810:3
 */
InvalidEncryptedTender.Reason = $root.lookupEnum('squareup.common.tender.InvalidEncryptedTender.Reason').values;
/**
 * Represents a credit card.  Can be either keyed-in card, swiped card, or a Fidelius token.
 *
 * SOURCE CardTender @ squareup/common/tender.proto at 835:1
 */
export const CardTender = $root.lookupType('squareup.common.tender.CardTender');
fixType(CardTender);
Builder.createAndAttachToType(CardTender);
/**
 * The types of credit cards we can process.
 *
 * SOURCE CardTenderType @ squareup/common/tender.proto at 876:1
 */
export const CardTenderType = $root.lookupEnum('squareup.common.tender.CardTenderType').values;
/**
 * Tender input type.
 *
 * SOURCE TenderInputType @ squareup/common/tender.proto at 936:1
 */
export const TenderInputType = $root.lookupEnum('squareup.common.tender.TenderInputType').values;
/**
 * Account types that may be associated with a card.
 *
 * SOURCE AccountType @ squareup/common/tender.proto at 1017:1
 */
export const AccountType = $root.lookupEnum('squareup.common.tender.AccountType').values;
/**
 * Provides an additional reasoning for the status of the is_success flag under AuthenticationResult
 *
 * SOURCE ThreeDSFailureReason @ squareup/common/tender.proto at 1029:1
 */
export const ThreeDSFailureReason = $root.lookupEnum('squareup.common.tender.ThreeDSFailureReason').values;
/**
 * 3DS error fields per EMVco specification
 *
 * SOURCE ThreeDSError @ squareup/common/tender.proto at 1060:1
 */
export const ThreeDSError = $root.lookupType('squareup.common.tender.ThreeDSError');
fixType(ThreeDSError);
Builder.createAndAttachToType(ThreeDSError);
/**
 * Cardholder name to be used for name verification requests.
 *
 * SOURCE CardHolderName @ squareup/common/tender.proto at 1074:1
 */
export const CardHolderName = $root.lookupType('squareup.common.tender.CardHolderName');
fixType(CardHolderName);
Builder.createAndAttachToType(CardHolderName);